import React from 'react';
import ConfirmActionDialog from 'src/components/common/dialogs/ConfirmActionDialog';

export type dialogCreator = {
    confirmAction: (title: string, body: string | React.ReactElement, onConfirm: () => void, onCancel?: () => void) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        confirmAction: (title: string, body: string | React.ReactElement, onConfirm: () => void, onCancel?: () => void) => {
            setDialog(
                React.createElement(ConfirmActionDialog, {
                    title,
                    body,
                    onConfirm,
                    onCancel,
                })
            );
        },
    };
};

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/common.ts